import { useEffect, useState } from 'react';
import { AlbumType } from '../../../types/models';
import { Area } from './components/Area/Area';
import { apiAlbumsGet } from '../../../actions/photoActions';
import TableSearchField from '../../../components/table/TableSearchField';
import PageNotFound from '../../pagenotfound/PageNotFound';
import { useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import axios from 'axios';

const elementsOnPage = 20;

const CancelToken = axios.CancelToken;
let source: any;

function PanelPhotos() {
  const [albums, setAlbums] = useState<AlbumType[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    getAlbums();
  }, [page]);

  const getAlbums = async () => {
    if (source) {
      source.cancel();
    }

    source = CancelToken.source();

    setLoading(true);
    const data = await apiAlbumsGet({
      limit: elementsOnPage,
      offset: page * elementsOnPage,
      cancelToken: source.token,
    });
    setAlbums(data.albums);
    setCount(data.count);
    setLoading(false);
  };

  const pagination = (
    <div className="table-page-paginations">
      <ReactPaginate
        forcePage={page}
        breakLabel="..."
        nextLabel=">"
        onPageChange={event => {
          setPage(event.selected);
        }}
        pageRangeDisplayed={3}
        pageCount={Math.ceil(count / elementsOnPage)}
        previousLabel="<"
      />
    </div>
  );

  const user = useSelector(state => state.user);

  if (user.user && parseInt(user.user.admin) === 0 && parseInt(user.user.ugc) === 0) {
    return <PageNotFound />;
  }

  return (
    <>
      <div className="table-page">
        <div className="table-page-top row">
          <span className="table-page-top-title">Photos</span>
          <button className="table-page-button table-page-create-button">
            <span className="table-page-button-label">Create album</span>
            <img className="table-page-button-icon" src="/images/create-button-icon.svg" alt="" />
          </button>
          <button className="table-page-button table-page-create-button">
            <span className="table-page-button-label">Upload photo</span>
            <img className="table-page-button-icon" src="/images/create-button-icon.svg" alt="" />
          </button>
          <TableSearchField search={''} onChange={(value: string) => {}} />
          <div className="table-page-top-right">
            {count > elementsOnPage && pagination}
            <span className="table-page-num-value">
              Total num: <b>{count}</b>
            </span>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="table-page-loader">
          <div className="lds-ripple">
            <div />
            <div />
          </div>
        </div>
      ) : (
        albums.map(album => <Area key={album.id} album={album} />)
      )}
      <div style={{ marginTop: '20px' }}>{count > elementsOnPage && pagination}</div>
    </>
  );
}

export default PanelPhotos;
